import { supportedChains } from './supported-chains'
import { BaseToken } from './tokens'

export const ALL_TOKENS = [
  {
    id: 'astar-substrate-assets-18446744073709551616-aca',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'ACA',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/aca.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551616',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'acala',
  },
  {
    id: 'astar-substrate-assets-18446744073709551617-aseed',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'aSEED',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/aseed.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551617',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'ausd-seed-acala',
  },
  {
    id: 'astar-substrate-assets-18446744073709551618-ldot',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'LDOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/ldot.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551618',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'liquid-staking-dot',
  },
  {
    id: 'astar-substrate-assets-18446744073709551619-glmr',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'GLMR',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/moonbeam.webp',
    existentialDeposit: '1',
    assetId: '18446744073709551619',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'moonbeam',
  },
  {
    id: 'astar-substrate-assets-18446744073709551620-ibtc',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'iBTC',
    decimals: 8,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/ibtc.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551620',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'interbtc',
  },
  {
    id: 'astar-substrate-assets-18446744073709551621-intr',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'INTR',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/intr.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551621',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'interlay',
  },
  {
    id: 'astar-substrate-assets-18446744073709551622-pha',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'PHA',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/pha.webp',
    existentialDeposit: '1',
    assetId: '18446744073709551622',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'pha',
  },
  {
    id: 'astar-substrate-assets-18446744073709551623-bnc',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'BNC',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/bnc.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551623',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'bifrost-native-coin',
  },
  {
    id: 'astar-substrate-assets-18446744073709551624-vdot',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'vDOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/vdot.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551624',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'voucher-dot',
  },
  {
    id: 'astar-substrate-assets-18446744073709551625-clv',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'CLV',
    decimals: 18,
    existentialDeposit: '1',
    assetId: '18446744073709551625',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/unknown.svg',
  },
  {
    id: 'astar-substrate-assets-18446744073709551626-vsdot',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'VSDOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/vsdot.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551626',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
  },
  {
    id: 'astar-substrate-assets-18446744073709551627-ring',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'RING',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/ring.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551627',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'darwinia-network-native-token',
  },
  {
    id: 'astar-substrate-assets-18446744073709551628-eq',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'EQ',
    decimals: 9,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/eq.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551628',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'equilibrium-token',
  },
  {
    id: 'astar-substrate-assets-18446744073709551633-pink',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'PINK',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/pink.png',
    existentialDeposit: '1',
    assetId: '18446744073709551633',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
  },
  {
    id: 'astar-substrate-assets-18446744073709551629-eqd',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'EQD',
    decimals: 9,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/eqd.svg',
    existentialDeposit: '1',
    assetId: '18446744073709551629',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
  },
  {
    id: 'astar-substrate-assets-340282366920938463463374607431768211455-dot',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'DOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/dot.svg',
    existentialDeposit: '1',
    assetId: '340282366920938463463374607431768211455',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'polkadot',
  },
  {
    id: 'astar-substrate-assets-4294969280-usdt',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'USDT',
    decimals: 6,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/usdt.svg',
    existentialDeposit: '1',
    assetId: '4294969280',
    isFrozen: false,
    chain: {
      id: 'astar',
    },
    coingeckoId: 'tether',
  },
  {
    id: 'astar-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'ASTR',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/astar.svg',
    existentialDeposit: '1000000',
    chain: {
      id: 'astar',
    },
    coingeckoId: 'astar',
  },
  {
    id: 'bifrost-polkadot-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'BNC',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/bifrost-polkadot.svg',
    existentialDeposit: '10000000000',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'bifrost-native-coin',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIAqB7A1jAdgJhAGhADcBDAGwFc54BmAXyA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'ASTR',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/astar.webp',
    existentialDeposit: '10000000000000000',
    onChainId: '{"Token2":3}',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'astar',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIAqB7A1jAdiANCAbgIYA2ArnPKJLAiAEIByAwiAL6tA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'BNC',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/bnc.svg',
    existentialDeposit: '0',
    onChainId: '{"Token":"BNC"}',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'bifrost-native-coin',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIAqB7A1jAdgJhAGhADcBDAGwFc54AGAXyA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'DOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/dot.svg',
    existentialDeposit: '1000000',
    onChainId: '{"Token2":0}',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'polkadot',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIAqB7A1jAdgJhAGhADcBDAGwFc54AWAXyA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'FIL',
    decimals: 18,
    existentialDeposit: '1000000000000',
    onChainId: '{"Token2":4}',
    chain: {
      id: 'bifrost-polkadot',
    },
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/unknown.svg',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIAqB7A1jAdgJhAGhADcBDAGwFc54BGAXyA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'GLMR',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/moonbeam.webp',
    existentialDeposit: '1000000000000',
    onChainId: '{"Token2":1}',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'moonbeam',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIAqB7A1jAdgJhAGhADcBDAGwFc54A2AXyA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'IBTC',
    decimals: 8,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/ibtc.svg',
    existentialDeposit: '100',
    onChainId: '{"Token2":6}',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'interbtc',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIAqB7A1jAdgJhAGhADcBDAGwFc54B2AXyA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'INTR',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/intr.svg',
    existentialDeposit: '10000000',
    onChainId: '{"Token2":7}',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'interlay',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIAqB7A1jAdgJhAGhADcBDAGwFc54BWAXyA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'USDC',
    decimals: 6,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/usd-coin.webp',
    existentialDeposit: '1000',
    onChainId: '{"Token2":5}',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'usd-coin',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIAqB7A1jAdgJhAGhADcBDAGwFc55sBfIA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'USDT',
    decimals: 6,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/usdt.svg',
    existentialDeposit: '1000',
    onChainId: '{"Token2":2}',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'tether',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIBqAVA9gaxgOwEwgBoQA3AQwBsBXOeAZgF8g',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'vASTR',
    decimals: 18,
    existentialDeposit: '10000000000000000',
    onChainId: '{"VToken2":3}',
    chain: {
      id: 'bifrost-polkadot',
    },
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/unknown.svg',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIBqAVA9gaxgOwEwgBoQA3AQwBsBXOeABgF8g',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'vDOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/vdot.svg',
    existentialDeposit: '1000000',
    onChainId: '{"VToken2":0}',
    chain: {
      id: 'bifrost-polkadot',
    },
    coingeckoId: 'voucher-dot',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIBqAVA9gaxgOwEwgBoQA3AQwBsBXOeAFgF8g',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'vFIL',
    decimals: 18,
    existentialDeposit: '1000000000000',
    onChainId: '{"VToken2":4}',
    chain: {
      id: 'bifrost-polkadot',
    },
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/unknown.svg',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIBqAVA9gaxgOwEwgBoQA3AQwBsBXOeARgF8g',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'vGLMR',
    decimals: 18,
    existentialDeposit: '1000000000000',
    onChainId: '{"VToken2":1}',
    chain: {
      id: 'bifrost-polkadot',
    },
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/unknown.svg',
  },
  {
    id: 'bifrost-polkadot-substrate-tokens-N4IgLgngDgpiBcIBqBlAKgewNYwHYCYQAaEANwEMAbAVzngAYBfIA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'vsDOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/vsdot.svg',
    existentialDeposit: '1000000',
    onChainId: '{"VSToken2":0}',
    chain: {
      id: 'bifrost-polkadot',
    },
  },
  {
    id: 'bittensor-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'TAO',
    decimals: 9,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/bittensor.svg',
    existentialDeposit: '500',
    chain: {
      id: 'bittensor',
    },
    coingeckoId: 'bittensor',
  },
  {
    id: 'hydradx-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'HDX',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/hydradx.svg',
    existentialDeposit: '1000000000000',
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'hydradx',
  },
  {
    id: 'hydradx-substrate-tokens-GxA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'APE',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/apecoin.webp',
    existentialDeposit: '2518891687657430',
    onChainId: 6,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'apecoin',
  },
  {
    id: 'hydradx-substrate-tokens-JxA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'ASTR',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/astar.webp',
    existentialDeposit: '147058823529412000',
    onChainId: 9,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'astar',
  },
  {
    id: 'hydradx-substrate-tokens-IwFiA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'BNC',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/bnc.svg',
    existentialDeposit: '68795189840',
    onChainId: 14,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'bifrost-native-coin',
  },
  {
    id: 'hydradx-substrate-tokens-IwZiA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'CFG',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/centrifuge.webp',
    existentialDeposit: '32467532467532500',
    onChainId: 13,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'centrifuge',
  },
  {
    id: 'hydradx-substrate-tokens-IwDiA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'DAI',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/dai.webp',
    existentialDeposit: '10000000000000000',
    onChainId: 2,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'dai',
  },
  {
    id: 'hydradx-substrate-tokens-KxA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'DOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/dot.svg',
    existentialDeposit: '17540000',
    onChainId: 5,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'polkadot',
  },
  {
    id: 'hydradx-substrate-tokens-IzI',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'iBTC',
    decimals: 8,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/ibtc.svg',
    existentialDeposit: '36',
    onChainId: 11,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'interbtc',
  },
  {
    id: 'hydradx-substrate-tokens-lrna',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'LRNA',
    decimals: 12,
    existentialDeposit: '400000000',
    onChainId: 1,
    chain: {
      id: 'hydradx',
    },
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/unknown.svg',
  },
  {
    id: 'hydradx-substrate-tokens-BxA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'PHA',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/pha.webp',
    existentialDeposit: '54945054945',
    onChainId: 8,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'pha',
  },
  {
    id: 'hydradx-substrate-tokens-OxA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'USDC',
    decimals: 6,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/usd-coin.webp',
    existentialDeposit: '10000',
    onChainId: 7,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'usd-coin',
  },
  {
    id: 'hydradx-substrate-tokens-IwBjHYDZyA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'USDT',
    decimals: 6,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/usdt.svg',
    existentialDeposit: '10000',
    onChainId: 10,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'tether',
  },
  {
    id: 'hydradx-substrate-tokens-IwViA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'vDOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/vdot.svg',
    existentialDeposit: '18761726',
    onChainId: 15,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'voucher-dot',
  },
  {
    id: 'hydradx-substrate-tokens-MxA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'WBTC',
    decimals: 8,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/bitcoin.webp',
    existentialDeposit: '44',
    onChainId: 3,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'bitcoin',
  },
  {
    id: 'hydradx-substrate-tokens-EwBiA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'WETH',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/ethereum.webp',
    existentialDeposit: '7000000000000',
    onChainId: 4,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'ethereum',
  },
  {
    id: 'hydradx-substrate-tokens-IwJiA',
    type: 'substrate-tokens',
    isTestnet: false,
    isDefault: true,
    symbol: 'ZTG',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/zeitgeist.webp',
    existentialDeposit: '1204151916',
    onChainId: 12,
    chain: {
      id: 'hydradx',
    },
    coingeckoId: 'zeitgeist',
  },
  {
    id: 'kusama-asset-hub-substrate-assets-16-aris',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'ARIS',
    decimals: 8,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/aris.svg',
    existentialDeposit: '10000000',
    assetId: '16',
    isFrozen: false,
    chain: {
      id: 'kusama-asset-hub',
    },
  },
  {
    id: 'kusama-asset-hub-substrate-assets-1984-usdt',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'USDT',
    decimals: 6,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/usdt.svg',
    existentialDeposit: '100',
    assetId: '1984',
    isFrozen: false,
    chain: {
      id: 'kusama-asset-hub',
    },
    coingeckoId: 'tether',
  },
  {
    id: 'kusama-asset-hub-substrate-assets-8-rmrk',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'RMRK',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/rmrk.svg',
    existentialDeposit: '10000',
    assetId: '8',
    isFrozen: false,
    chain: {
      id: 'kusama-asset-hub',
    },
    coingeckoId: 'rmrk',
  },
  {
    id: 'kusama-asset-hub-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'KSM',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/kusama-asset-hub.svg',
    existentialDeposit: '3333333',
    chain: {
      id: 'kusama-asset-hub',
    },
    coingeckoId: 'kusama',
  },
  {
    id: 'kusama-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'KSM',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/kusama.svg',
    existentialDeposit: '333333333',
    chain: {
      id: 'kusama',
    },
    coingeckoId: 'kusama',
  },
  {
    id: 'moonbeam-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'GLMR',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/moonbeam.svg',
    existentialDeposit: '0',
    chain: {
      id: 'moonbeam',
    },
    coingeckoId: 'moonbeam',
  },
  {
    id: 'phala-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'PHA',
    decimals: 12,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/phala.svg',
    existentialDeposit: '10000000000',
    chain: {
      id: 'phala',
    },
    coingeckoId: 'pha',
  },
  {
    id: 'polkadot-asset-hub-substrate-assets-1337-usdc',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'USDC',
    decimals: 6,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/usd-coin.webp',
    existentialDeposit: '700000',
    assetId: '1337',
    isFrozen: false,
    chain: {
      id: 'polkadot-asset-hub',
    },
    coingeckoId: 'usd-coin',
  },
  {
    id: 'polkadot-asset-hub-substrate-assets-1984-usdt',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'USDT',
    decimals: 6,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/usdt.svg',
    existentialDeposit: '700000',
    assetId: '1984',
    isFrozen: false,
    chain: {
      id: 'polkadot-asset-hub',
    },
    coingeckoId: 'tether',
  },
  {
    id: 'polkadot-asset-hub-substrate-assets-23-pink',
    type: 'substrate-assets',
    isTestnet: false,
    isDefault: true,
    symbol: 'PINK',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/pink.png',
    existentialDeposit: '1',
    assetId: '23',
    isFrozen: false,
    chain: {
      id: 'polkadot-asset-hub',
    },
  },
  {
    id: 'polkadot-asset-hub-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'DOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/polkadot-asset-hub.svg',
    existentialDeposit: '1000000000',
    chain: {
      id: 'polkadot-asset-hub',
    },
    coingeckoId: 'polkadot',
  },
  {
    id: 'polkadot-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'DOT',
    decimals: 10,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/polkadot.svg',
    existentialDeposit: '10000000000',
    chain: {
      id: 'polkadot',
    },
    coingeckoId: 'polkadot',
    dcentName: 'POLKADOT',
  },
  {
    id: 'mythos-substrate-native',
    type: 'substrate-native',
    isTestnet: false,
    isDefault: true,
    symbol: 'MYTH',
    decimals: 18,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/mythos.svg',
    existentialDeposit: '10000000000000000',
    chain: {
      id: 'mythos',
    },
    coingeckoId: 'mythos',
  },
]

export const ALL_TOKENS_BY_ID = ALL_TOKENS.reduce((a, b) => {
  const chain = supportedChains.find(c => c.id === b.chain.id)
  if (!chain) return a
  a[b.id] = {
    ...b,
    chain,
  }
  return a
}, {} as Record<string, BaseToken>)

export const getTokenById = (id: string) => ALL_TOKENS_BY_ID[id]
